import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/execucao";

/**
 * Classe de gerenciamento de chamadas da API dos Execucao
 *
 * @class
 */
export default class ExecucaoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe ExecucaoApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns execucao
   */
    lerRegistro(codExecucao: number) {

        return this.api<ApplicationModule[]>(`${controller}/lerregistro`, {
            method: "GET",
            params: { codExecucao }
        });
    }

    /**
  * @returns membroEquipe
  */
    membroEquipe_Listar(codAgendamento: number, codOperadora: number) {

        return this.api<ApplicationModule[]>(`${controller}/membroequipe_listar`, {
            method: "GET",
            params: { codAgendamento, codOperadora }
        });
    }

    /**
 * @returns lista de Execucao por codGuia
 */
    listar(codGuia: number) {

        return this.api<ApplicationModule[]>(`${controller}/listar`, {
            method: "GET",
            params: { codGuia }
        });
    }

}